export default "__VITE_ASSET__rghqTfpQ__"